/*
 * Initials for an avatar/tile: first letters of the first two words, else the first two
 * characters, else '?'.
 *
 * Splits on /\s+/ and filters empties — a naive split(' ') on "Ann  Lee" yields
 * ['Ann', '', 'Lee'], and the empty middle produces "ANNUNDEFINED".
 */
export const getInitials = (name = '') => {
  const words = String(name).trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};
